<template>
  <WeatherContainer>
    <div class="register">
      <div class="form-title">
        用户注册
      </div>
      <div class="form">
        <!-- 用户名 -->
        <div class="form-item required">
          <div class="label">
            用户名
          </div>
          <div class="input">
            <input type="text" v-model="formData.username" placeholder="请输入单位营业执照全称">
          </div>
        </div>
        <!-- 手机号 -->
        <div class="form-item required">
          <div class="label">
            手机号
          </div>
          <div class="input">
            <input type="text" v-model="formData.phone" placeholder="请输入手机号">
          </div>
        </div>
        <!-- 验证码 -->
        <div class="form-item required getcode">
          <div class="label">
            验证码
          </div>
          <div class="input">
            <input type="text" v-model="formData.code" placeholder="请输入手机验证码">
            <input type="button" :class="{timer: timer}" :value="codeTip" @click="handleGetCode">
          </div>
        </div>
        <!-- 密码 -->
        <div class="form-item required">
          <div class="label">
            密码
          </div>
          <div class="input">
            <input type="password" v-model="formData.password1" placeholder="请输入您的登录密码">
          </div>
        </div>
        <!-- 确认密码 -->
        <div class="form-item required">
          <div class="label">
            确认密码
          </div>
          <div class="input">
            <input type="password" v-model="formData.password2" placeholder="请再次输入您的登录密码">
          </div>
        </div>
        <!-- 协议 -->
        <div class="xieyi">
          <input type="checkbox" name="isread" id="isread" v-model="isread">
          <p>已阅读并同意签署 <b @click="showAgree = true">《会员管理办法》</b><b @click="showAgree = true">《章程》</b></p>
        </div>
        <input type="button" value="立即注册" class="submit" @click="handleSubmit">
        <div class="intro">
          已经有账号？点击这里 <b @click="$router.push('/Login')">登录</b>                
        </div>
      </div>
      <Modal
        width="1200"
        v-if="agreement"
        v-model="showAgree"
        :title="agreement.title">
        <div v-html="agreement.content"></div>
        <div slot="footer">
        </div>
      </Modal>
    </div>
  </WeatherContainer>
</template>
<script>
import WeatherContainer from '@/components/WeatherContainer'
import { Modal, Notice } from 'iview';
export default {
  components: {WeatherContainer, Modal},
  data() {
    return {
      codeTip: '获取验证码',
      showTimer: false,
      time: 60,
      agreement: null,
      isread: false,
      showAgree: false,
      timer: 0,
      formData: {
        username: '',
        phone: '',
        code: '',
        password1: '',
        password2: '',
      }
    }
  },
  methods: {
    handleGetCode() {
      if(this.showTimer) {
        Notice.error({
            title: '请稍后再试',
            desc: ''
        });
        return false
      }
      const phone = this.formData.phone
      if(phone) {
        this.$store.dispatch('send_msg', {phone})
        .then(res => {
          if(res) {
            Notice.success({
                title: '发送成功！',
                desc: ''
            });
            this.showTimer = true
            this.codeTip = this.time + '秒后重试'
            this.timer = setInterval(() => {
              --this.time
              this.codeTip = this.time + '秒后重试'
              if(this.time === 0) {
                this.time = 60
                this.showTimer = false
                this.codeTip = '获取验证码'
                clearInterval(this.timer)
                this.timer = 0
              }
            }, 1000)
          }
        })
      }else {
        Notice.error({
            title: '请输入手机号',
            desc: ''
        });
      }
    },
    handleSubmit() {
      if(this.isread) {
        this.$store.dispatch('register', {...this.formData})
        .then(res => {
          Notice.success({
              title: '注册成功！',
              desc: ''
          });
          this.$router.push('/Login')
        })
      }else {
        Notice.error({
            title: '请签署协议后再提交。',
            desc: ''
        });
      }
    }
  },
  mounted() {
    this.$store.dispatch('get_agreement')
    .then(res => {
      this.agreement = res
    })
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
.register {
  padding: 0 2.6rem;
  box-sizing: border-box;
  .form-title {
    text-align: center;
    line-height: 5.15rem;
    font-size: 1.2rem;
    color: #000;
  }
  .form {
    .form-item {
      margin-bottom: 1rem;
      height: 2.3rem;
        box-sizing: border-box;
      .label {
        height: 100%;
        line-height: 2.3rem;
        width: 4.75rem;
        float: left;
      }
      .input {
        width: 20rem;
        height: 2.3rem;
        float: left;
        input {
          width: 100%;
          height: 100%;
          padding-left: 0.6rem;
          outline: 0 none;
          border: 1px solid #eee;
          color: #333;
          font-weight: 700;
          &::placeholder {
            color: rgba(204, 204, 204, 1)
          }
        }
      }
    }
    .form-item.required {
      .label {
        padding-left: 0.6rem;
        position: relative;
        &::before {
          content: "*";
          line-height: 1rem;
          color: rgba(246, 80, 80, 1);
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }
    .form-item.getcode {
      .input {
        input:nth-child(1) {
          width: 12.5rem;
        }
        input:nth-child(2) {
          width: 7rem;
          float: right;
          background:@btn-background;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
        }
        input.timer {
          background: #ccc;
        }
      }
    }
    .xieyi {
      p {
        display: inline-block;
        margin-left: 0.3rem;
        transform: translateY(-0.1rem);
      }
      b {
        color:@btn-background;
        cursor: pointer;
      }
    }
    .submit {
      width: 24.8rem;
      height: 2.7rem;
      background: @btn-background;
      color: #fff;
      outline: 0 none;
      border: 0 none;
      cursor: pointer;
      font-size: 0.8rem;
      font-weight: 700;
    }
    .intro {
      margin-top: 0.8rem;
      b {
        color: @btn-background;
        cursor: pointer;
      }
    }
  }
}
</style>
